"use strict";

exports.__esModule = true;
exports.formatUpperCase = exports.formatPhoneNumberWithSpaces = exports.formatNumberWithSpaces = exports.formatNationalInsurance = exports.formatInviteCode = exports.formatCurrency = void 0;

// Format the value to be uppercase
const formatUpperCase = value => {
  return value ? value.toUpperCase() : '';
};

exports.formatUpperCase = formatUpperCase;

const formatCurrency = value => {
  if (!value) {
    return '';
  } // Replace non-decimal characters


  value = value.replace(/[^\d.]/g, ''); // Only allow a decimal place after a number 

  value = value.replace(/^\./g, ''); // Only allow a single decimal place and maximum of 2 decimal places

  const decimals = value.split('.');

  if (decimals.length === 2) {
    value = `${parseFloat(decimals[0]).toLocaleString('en')}.${decimals[1].substring(0, 2)}`;
  } else if (decimals.length >= 3) {
    value = `${parseFloat(decimals[0]).toLocaleString('en')}.`;
    decimals.shift();
    value += decimals.join('').substring(0, 2);
  } else {
    value = parseFloat(value).toLocaleString('en');
  }

  return value;
};

exports.formatCurrency = formatCurrency;

const formatNationalInsurance = value => {
  if (!value) {
    return '';
  }

  const onlyAlphaNumeric = value.replace(/[^\da-zA-Z]/g, '').toUpperCase();

  if (onlyAlphaNumeric.length <= 2) {
    return onlyAlphaNumeric;
  }

  if (onlyAlphaNumeric.length <= 4) {
    return `${onlyAlphaNumeric.slice(0, 2)} ${onlyAlphaNumeric.slice(2)}`;
  }

  if (onlyAlphaNumeric.length <= 6) {
    return `${onlyAlphaNumeric.slice(0, 2)} ${onlyAlphaNumeric.slice(2, 4)} ${onlyAlphaNumeric.slice(4)}`;
  }

  if (onlyAlphaNumeric.length <= 8) {
    return `${onlyAlphaNumeric.slice(0, 2)} ${onlyAlphaNumeric.slice(2, 4)} ${onlyAlphaNumeric.slice(4, 6)} ${onlyAlphaNumeric.slice(6)}`;
  }

  return `${onlyAlphaNumeric.slice(0, 2)} ${onlyAlphaNumeric.slice(2, 4)} ${onlyAlphaNumeric.slice(4, 6)} ${onlyAlphaNumeric.slice(6, 8)} ${onlyAlphaNumeric.slice(8, 9)}`;
};

exports.formatNationalInsurance = formatNationalInsurance;

const formatInviteCode = value => {
  if (!value) {
    return '';
  }

  const onlyAlphaNumeric = value.replace(/[^\da-zA-Z]/g, '').toUpperCase().substring(0, 10);

  if (onlyAlphaNumeric.length <= 5) {
    return onlyAlphaNumeric;
  } else {
    return `${onlyAlphaNumeric.slice(0, 5)} - ${onlyAlphaNumeric.slice(5)}`;
  }
};

exports.formatInviteCode = formatInviteCode;

const formatNumberWithSpaces = value => {
  if (!value) {
    return '';
  }

  value = value.replace(/[^\d\s]/g, '');
  return value;
};

exports.formatNumberWithSpaces = formatNumberWithSpaces;

const formatPhoneNumberWithSpaces = value => {
  if (!value) {
    return '';
  }

  value = value.replace(/[^\d\s+]/g, '');
  return value;
};

exports.formatPhoneNumberWithSpaces = formatPhoneNumberWithSpaces;